const baseurl = process.env.REACT_APP_BASE_URL

// Feature flags
export const API_FEATURE_FLAGS = `${baseurl}/dtc/api/features`;

// Auth Api Urls
export const API_LOGIN = `${baseurl}/dtc/api/account/login`;
export const CHANGE_PASSWORD_TEMP = `${baseurl}/dtc/api/account/expired-password`;
export const API_LOGOUT = `${baseurl}/api/logout`;
export const API_REFRESH_TOKEN = `${baseurl}/dtc/api/token/refresh`;


// User Profile
export const API_USER_PROFILE =  `${baseurl}/dtc/api/account/user-profile`;
export const API_PASSWORD_CHANGE  = `${baseurl}/dtc/api/account/password`;

// Email migration
export const API_EMAIL_CHANGE_REQUEST = `${baseurl}/dtc/api/account/email-change/request`;
export const API_EMAIL_CHANGE_VERIFY = (token) =>
  `${baseurl}/dtc/api/account/email-change/verify?token=${encodeURIComponent(token)}`;
export const API_EMAIL_CHANGE_RESEND = `${baseurl}/dtc/api/account/email-change/resend`;
export const API_EMAIL_CHANGE_STATUS = `${baseurl}/dtc/api/account/email-change/status`;

// Update Tenent Details
// export const API_TENANT_DETAILS = `${baseurl}/dtc/api/account/save-tenant`;


// Homepage content 
export const API_HOMEPAGE_CONTENT = `${baseurl}/dtc/api/home`


// What's new
export const API_WHATNEW_CONTENT = `${baseurl}/dtc/api/whats-new`

// faq
export const API_FAQ_QUESTION = `${baseurl}/dtc/api/faq`

// Alert Msg Url
export const API_ALERT = `${baseurl}/dtc/api/alert-message`;


// Demo Catalgue
export const API_DEMO_CATALGUE = `${baseurl}/dtc/api/demo/demo-catalogue`

// Demo Catalgue Details
export const API_DEMO_CATALOGUE_DETAILS = (id) => `${baseurl}/dtc/api/demo/demo-catalogue/${id}`;

// Get reset page content
export const API_RESET_PAGE_CONTENT =`${baseurl}/dtc/api/reset/details`;


// Get Content
export const API_CONTENT_GET = `${baseurl}/dtc/api/content/`



// Ingest SIH URl // Same Payload
export const API_INGEST_SIH_NARRATIVE = `${baseurl}/dtc/api/demo/sih`
export const API_INGEST_SERVICE_PREDICTION = `${baseurl}/dtc/api/demo/service-predictions`
export const API_INGEST_CHANGE_MANAGEMENT =  `${baseurl}/dtc/api/demo/change-management`
export const API_INGEST_CXO_DASHBOARD =  `${baseurl}/dtc/api/demo/cxo`
export const API_INGEST_END_TO_END =  `${baseurl}/dtc/api/demo/e2e-observability`
export const API_INGEST_POLICY_BASED_CLUSTER =  `${baseurl}/dtc/api/demo/policy-events`
export const API_INGEST_SECOPS = `${baseurl}/dtc/api/demo/secops-aiops`
export const API_INGEST_ONE_BMC = `${baseurl}/dtc/api/demo/mainframe`


// Service Ops 
export const API_INGEST_SERVICE_OPS_MS_FULL = `${baseurl}/dtc/api/demo/service-ops-ms`
export const API_INGEST_SERVICE_OPS_MS_ITSM = `${baseurl}/dtc/api/demo/ms-incidents`
export const API_INGEST_SERVICE_OPS_MS_BHOM = `${baseurl}/dtc/api/demo/ms-events`
export const API_INGEST_SERVICE_OPS_IB_FULL = `${baseurl}/dtc/api/demo/service-ops-ib`
export const API_INGEST_SERVICE_OPS_IB_ITSM = `${baseurl}/dtc/api/demo/ib-incidents`  
export const API_INGEST_SERVICE_OPS_IB_BHOM = `${baseurl}/dtc/api/demo/ib-events`



// CSM API Endpoint URL
export const API_INGEST_CSM_POST_CSM_MS = `${baseurl}/dtc/api/demo/csm-ms`
export const API_INGEST_CSM_POST_CSM_IB = `${baseurl}/dtc/api/demo/csm-ib`
export const API_INGEST_CSM_POST_CSM_AW = `${baseurl}/dtc/api/demo/csm-aw`


// Observabilty
export const API_INGEST_OBSERVABILTY_MS = `${baseurl}/dtc/api/demo/observability-ms` 
export const API_INGEST_OBSERVABILTY_IB = `${baseurl}/dtc/api/demo/observability-ib`
export const API_INGEST_OBSERVABILTY_AISM_MS = `${baseurl}/dtc/api/demo/observability-aism-ms`
export const API_INGEST_OBSERVABILTY_AISM_IB = `${baseurl}/dtc/api/demo/observability-aism-ib`


// Build Your OWn
export const API_INGEST_BYO_BHOM = `${baseurl}/dtc/api/demo/byo-events`;
export const API_INGEST_BYO_ITSM = `${baseurl}/dtc/api/demo/byo-incidents`;



// Banking Apis
export const API_INGEST_BANKING_NETWORK_OUTAGE = `${baseurl}/dtc/api/demo/network-outage-ab`;
export const API_INGEST_BANKING_UNAUTHEIRZED_CHNAGE = `${baseurl}/dtc/api/demo/unauthorized-change-ab`;


// HRSM 
export const API_INGEST_HRSM = `${baseurl}/dtc/api/demo/hrsm`


// One Model, All Industries (Rename)
export const API_INGEST_ONE_MODEL_ALL_INDUSTRIES_RENAME = `${baseurl}/dtc/api/demo/rename-service`;

// Reset Api
export const API_RESET_BHOM_EVENTS = `${baseurl}/dtc/api/demo/reset-bhom-events`
export const API_RESET_ITSM_INCIDENTS = `${baseurl}/dtc/api/demo/reset-itsm-incidents` 
export const API_RESET_FULL_DEMO = `${baseurl}/dtc/api/demo/reset-full-demo` 






// Learning Hub
export const API_LEARNING_HUB = `${baseurl}/dtc/api/learning-hub`

// Micro certs Details
export const API_LEARNING_HUB_MICRO_DETAILS = (id) => `${baseurl}/dtc/api/learning-hub/${id}`;

// Update Video Status
export const API_LEARNING_HUN_UPDATE_VIDEO_STATUS = (id)=>`${baseurl}/dtc/api/learning-hub/${id}`

// Verify Quiz
export const API_LEARNING_HUN_QUIZ_VERIFY = (id) => `${baseurl}/dtc/api/learning-hub/${id}`

// Content Store
export const API_GET_CONTENT_STORE = `${baseurl}/dtc/api/content-store`



// Tenent Booking
export const API_GET_ALL_TENENT_BOOKINGS  = `${baseurl}/dtc/api/booking/get-tenants`;
export const API_BOOK_TENENT = `${baseurl}/dtc/api/booking/book-tenant`;
export const API_RELEASE_TENENT = `${baseurl}/dtc/api/booking/release-tenant`;



// Generic Search 
export const API_GENERIC_SEARCH  = `${baseurl}/dtc/api/search?`;
// Narrative Search
export const API_NARRATIVE_SEARCH  = `${baseurl}/dtc/api/narrative/search?`;
// FAQ Search
export const API_FAQ_SEARCH  = `${baseurl}/dtc/api/faq/search?`;
// Content STore Search
export const API_CONTENT_SEARCH  = `${baseurl}/dtc/api/content/search?`;
// -------------Analytics----------------//
// Fetch SE Analytics 
export const API_FETCH_SE_ANALYTICS = `${baseurl}/dtc/api/analytics/se`
// Fetch Manager Analytics
export const API_FETCH_MANAGER_ANALYTICS = `${baseurl}/dtc/api/analytics/se-manager?filter=`
// Fetch Leadership Analytics
export const API_FETCH_LEADERSHIP_ANALYTICS = `${baseurl}/dtc/api/analytics/leadership?filter=`
// Fetch Leadership Internal SE Analytics (Phase 1-B)
export const API_FETCH_LEADERSHIP_INTERNAL_SE_ANALYTICS = `${baseurl}/dtc/api/analytics/leadership/internal-se`
// Fetch Leadership Partner Analytics (Phase 2-B)
export const API_FETCH_LEADERSHIP_PARTNER_ANALYTICS = `${baseurl}/dtc/api/analytics/leadership/partners`
// Fetch Leadership Partner Company Analytics (Phase 3-B)
export const API_FETCH_LEADERSHIP_PARTNER_COMPANY_ANALYTICS = `${baseurl}/dtc/api/analytics/leadership/partners/company`
// Fetch Leadership Bootcamp Stats Overview
export const API_FETCH_LEADERSHIP_BOOTCAMP_STATS = `${baseurl}/dtc/api/analytics/leadership/bootcamp-stats`
// Fetch Leadership Bootcamp Stats Participants
export const API_FETCH_LEADERSHIP_BOOTCAMP_PARTICIPANTS = `${baseurl}/dtc/api/analytics/leadership/bootcamp-stats/participants`
// Fetch SE Impact Analytics HTML
export const API_FETCH_SE_IMPACT_STATS = `${baseurl}/dtc/api/analytics/se-impact-stats`
// Fetch VE Impact Analytics HTML
export const API_FETCH_VE_IMPACT_STATS = `${baseurl}/dtc/api/analytics/ve-impact-stats`
//--------------Sales Apis------------------//
// Fetch Sales Personas 
export const API_FETCH_SALES_PERSONAS_HOMEPAGE = `${baseurl}/dtc/api/sales-demo`

// Existing Demo Session
export const API_FETCH_EXISTING_DEMO_SESSION =(id)=> `${baseurl}/dtc/api/sales-demo/customer-demo/${id}`


// Customer Demo 
export const API_CREATE_CUSTOMER_DEMO_SESSION =(id)=> `${baseurl}/dtc/api/sales-demo/customer-demo/${id}`


// Internal Demo 
export const API_CREATE_INTERNAL_DEMO_SESSION =(id)=> `${baseurl}/dtc/api/sales-demo/internal-demo/${id}`



// Delete Demo 
export const API_DELETE_DEMO_SESSION = `${baseurl}/dtc/api/sales-demo/update-customer-demo`;


// Update Demo Session Status
export const API_UPDATE_DEMO_SESSION_STATUS = `${baseurl}/dtc/api/sales-demo/update-customer-demo`;// Get Partner Disaclimer API
export const API_GET_PARTNER_DISCLAIMER = `${baseurl}/dtc/api/disclaimer/get-partner-disclaimer`;
// Update Status Discalimer
export const API_UPDATE_DISCLAIMER_STATUS = `${baseurl}/dtc/api/disclaimer/update-status`;// Get Sales Walkthorugh Data
export const API_GET_SALES_WALKTHROUGH = `${baseurl}/dtc/api/sales-demo-tutorial`;
// Update Sales Walkthorugh Status
export const API_UPDATE_SALES_WALKTHROUGH_STATUS = `${baseurl}/dtc/api/sales-demo-tutorial/update-user`;// Get Analytics Filters
export const API_GET_ANALYTICS_FILTER = `${baseurl}/dtc/api/analytics/filters`;
// VulOps Apis
export const API_INGEST_VULOPS = `${baseurl}/dtc/api/demo/vulnerability-ops`;




//Get Upgrade Patches
export const API_GET_UPGRADE_PATCHES = `${baseurl}/dtc/api/upgrade/get-upgrades`;


// Post Upgrade Request
export const API_POST_UPGRADE_REQUEST = `${baseurl}/dtc/api/upgrade/upgrade-tenant`;// Yads 
export const API_GET_TENANT_SCENARIO_GROUPS = `${baseurl}/dtc/api/get-scenarios`;

export const API_GET_POLLING_STATUS = `${baseurl}/dtc/api/get-ingestion-status`;

export const API_YADS_DEMO_INGESTION = `${baseurl}/dtc/api/demo-scenario`;

// urls.js (where you define API_* constants)
export const API_SCHEDULE_YADS_DEMO_INGESTION = `${baseurl}/dtc/api/schedule/demo-scenario`;


// urls.js (with your other API_* constants)
export const API_CANCEL_YADS_SCHEDULE = (taskId) =>
  `${baseurl}/dtc/api/schedule/demo-scenario/${taskId}`;

// urls.js
export const API_YADS_SCHEDULE = (taskId) =>
  `${baseurl}/dtc/api/schedule/demo-scenario/${taskId}`;



// Recurring Scheduling
export const API_RECURRING_SCHEDULE_YADS_DEMO_INGESTION =
  `${baseurl}/dtc/api/recurring-schedule/demo-scenario`;


export const API_DELETE_YADS_RECURRING_SCHEDULE = (taskId) =>
  `${baseurl}/dtc/api/recurring-schedule/demo-scenario/${taskId}`;

// ---- URL builder (same shape as delete) ----
export const API_PATCH_YADS_RECURRING_SCHEDULE = (taskId) =>
  `${baseurl}/dtc/api/recurring-schedule/demo-scenario/${taskId}`;




// Onboard tenant
export const API_ONBOARD_TENANT = `${baseurl}/dtc/api/onboard-tenant`;


// POST: Forgot Password (NO TOKEN)
export const API_FORGOT_PASSWORD = `${baseurl}/dtc/api/account/password/reset/request`;


// Endpoint
export const API_CHANGE_PASSWORD_BY_URL = `${baseurl}/dtc/api/account/password/reset`;


// ✅ NEW: update tenant details for current user
export const API_PATCH_USER_TENANT = `${baseurl}/dtc/api/user/tenants`;


// ✅ optional (explicit delete alias)
export const API_DELETE_USER_TENANT = `${baseurl}/dtc/api/user/tenants`;
export const API_TENANT_DETAILS = `${baseurl}/dtc/api/user/tenants`;

// Cancel running ingestion (current tab)
export const API_CANCEL_INGESTION = (taskId) =>
  `${baseurl}/dtc/api/demo-scenario/cancel-ingestion/${taskId}`;


// Admin Users
export const API_ACCOUNT_REQUEST = `${baseurl}/dtc/api/account/request`;
export const API_ADMIN_PENDING_REQUEST = (requestId) =>
  `${baseurl}/dtc/api/admin/accounts/pending-requests/${requestId}`;
export const API_ADMIN_USER_MODULE_DETAILS = `${baseurl}/dtc/api/admin/accounts/overview`;
export const API_ADMIN_ACCOUNTS = `${baseurl}/dtc/api/admin/accounts`;
export const API_ADMIN_RESET_USER_PASSWORD = `${baseurl}/dtc/api/admin/accounts/reset-password`;
export const API_ADMIN_PENDING_REQUEST_COUNT = `${baseurl}/dtc/api/admin/accounts/pending-requests/count`;
export const API_ADMIN_ACCOUNT_TYPE_MAPPING = `${baseurl}/dtc/api/admin/account-types`;

// Admin Shared Tenants
export const API_ADMIN_SHARED_TENANT = `${baseurl}/dtc/api/admin/shared-tenant`;
export const API_ADMIN_BOOKING_LABELS = `${baseurl}/dtc/api/admin/booking-labels`;
export const API_ADMIN_BOOKING_TENANT_FEATURES = `${baseurl}/dtc/api/admin/booking-tenant-features`;
export const API_ADMIN_BOOKING_VERSION_FEATURES = `${baseurl}/dtc/api/admin/booking-version-features`;
export const API_ADMIN_UPDATE_FAULT_STATUS = `${baseurl}/dtc/api/admin/update-fault-status`;
export const API_ADMIN_MASS_PASSWORD_RESET = `${baseurl}/dtc/api/admin/shared-tenant/mass-password-reset`;
export const API_ADMIN_CHECK_CLEAN_TENANTS = `${baseurl}/dtc/api/admin/check-clean-tenants`;

// Admin Alerts
export const API_ADMIN_ALERT_MESSAGE = `${baseurl}/dtc/api/admin/alert-message`;

// Partner Portal
export const API_PARTNER_PORTAL_FORM_OPTIONS = `${baseurl}/dtc/api/partner-portal/form-options`;
export const API_PARTNER_PORTAL_SUBMIT = `${baseurl}/dtc/api/partner-portal/submit`;
export const API_PARTNER_PORTAL_MY_PROJECTS = `${baseurl}/dtc/api/partner-portal/my-projects`;
export const API_PARTNER_PORTAL_PAE_PROJECT_QUEUE = `${baseurl}/dtc/api/partner-portal/pae/project-queue`;
export const API_PARTNER_PORTAL_PAE_PROJECT_DETAIL = (id) =>
  `${baseurl}/dtc/api/partner-portal/pae/projects/${id}`;
export const API_PARTNER_PORTAL_PAE_PROJECT_ACTIONS = (id) =>
  `${baseurl}/dtc/api/partner-portal/pae/projects/${id}/actions`;
export const API_PARTNER_PORTAL_PROJECT_DETAIL = (id) =>
  `${baseurl}/dtc/api/partner-portal/my-projects/${id}`;
export const API_PARTNER_PORTAL_PARTNER_COMPANIES = `${baseurl}/dtc/api/partner-portal/partner-companies`;
export const API_PARTNER_PORTAL_PARTNER_COMPANIES_FORM_OPTIONS =
  `${baseurl}/dtc/api/partner-portal/partner-companies/form-options`;
export const API_PARTNER_PORTAL_PARTNER_COMPANY_DETAIL = (id) =>
  `${baseurl}/dtc/api/partner-portal/partner-companies/${id}`;
export const API_PARTNER_PORTAL_LEADERSHIP_PIPELINE = `${baseurl}/dtc/api/partner-portal/leadership/pipeline`;
export const API_PARTNER_PORTAL_LEADERSHIP_PIPELINE_PROJECTS =
  `${baseurl}/dtc/api/partner-portal/leadership/pipeline/projects`;
export const API_PARTNER_PORTAL_PROJECT_MASTER_DATA = `${baseurl}/dtc/api/partner-portal/project-master-data`;
export const API_PARTNER_PORTAL_PROJECT_MASTER_DATA_ITEMS = `${baseurl}/dtc/api/partner-portal/project-master-data/items`;
